import { blue, gray, green } from '@kizen/kds/Colors';

type TFn = (x: string) => string;

export const checkbox = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="11.5"
      height="11.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
  </svg>
);

export const checkboxes = () => (
  <svg
    width="57"
    height="34"
    viewBox="0 0 57 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="22.25"
      width="11.5"
      height="11.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <rect
      x="0.25"
      y="0.25"
      width="11.5"
      height="11.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M18.51 5.67C18.51 7.64 19.84 9.12 21.82 9.12C23.79 9.12 25.13 7.64 25.13 5.67C25.13 3.7 23.79 2.22 21.82 2.22C19.84 2.22 18.51 3.7 18.51 5.67ZM24.27 5.67C24.27 7.22 23.31 8.38 21.82 8.38C20.32 8.38 19.37 7.22 19.37 5.67C19.37 4.11 20.32 2.96 21.82 2.96C23.31 2.96 24.27 4.11 24.27 5.67ZM27.1465 10.84V8.27C27.5365 8.81 28.1165 9.12 28.7765 9.12C30.0465 9.12 30.9265 8.14 30.9265 6.58C30.9265 5.01 30.0465 4.05 28.7765 4.05C28.0965 4.05 27.4965 4.4 27.1465 4.89V4.17H26.3965V10.84H27.1465ZM30.1365 6.58C30.1365 7.65 29.5565 8.45 28.5865 8.45C27.9965 8.45 27.4065 8.09 27.1465 7.67V5.49C27.4065 5.07 27.9965 4.72 28.5865 4.72C29.5565 4.72 30.1365 5.51 30.1365 6.58ZM33.3587 9.12C33.7987 9.12 34.0687 8.99 34.2587 8.81L34.0387 8.25C33.9387 8.36 33.7387 8.45 33.5287 8.45C33.1987 8.45 33.0387 8.19 33.0387 7.83V4.83H34.0187V4.17H33.0387V2.85H32.2887V4.17H31.4887V4.83H32.2887V7.99C32.2887 8.71 32.6487 9.12 33.3587 9.12ZM35.4481 3.36C35.7281 3.36 35.9581 3.13 35.9581 2.85C35.9581 2.57 35.7281 2.35 35.4481 2.35C35.1781 2.35 34.9481 2.57 34.9481 2.85C34.9481 3.13 35.1781 3.36 35.4481 3.36ZM35.0781 9H35.8281V4.17H35.0781V9ZM39.4342 9.12C40.9042 9.12 41.8242 7.98 41.8242 6.58C41.8242 5.18 40.9042 4.05 39.4342 4.05C37.9642 4.05 37.0442 5.18 37.0442 6.58C37.0442 7.98 37.9642 9.12 39.4342 9.12ZM39.4342 8.45C38.4042 8.45 37.8242 7.57 37.8242 6.58C37.8242 5.6 38.4042 4.72 39.4342 4.72C40.4642 4.72 41.0342 5.6 41.0342 6.58C41.0342 7.57 40.4642 8.45 39.4342 8.45ZM46.3069 9H47.0569V5.61C47.0569 4.56 46.5269 4.05 45.5169 4.05C44.7969 4.05 44.1369 4.47 43.7969 4.87V4.17H43.0469V9H43.7969V5.47C44.0769 5.08 44.6369 4.72 45.2269 4.72C45.8769 4.72 46.3069 4.99 46.3069 5.84V9ZM55.9528 9H56.8728L54.1828 2.33H53.1528L50.4728 9H51.3928L51.9828 7.52H55.3628L55.9528 9ZM53.6728 3.07L55.1128 6.78H52.2228L53.6728 3.07Z"
      fill={gray['gray-800']}
    />
    <path
      d="M18.51 27.67C18.51 29.64 19.84 31.12 21.82 31.12C23.79 31.12 25.13 29.64 25.13 27.67C25.13 25.7 23.79 24.22 21.82 24.22C19.84 24.22 18.51 25.7 18.51 27.67ZM24.27 27.67C24.27 29.22 23.31 30.38 21.82 30.38C20.32 30.38 19.37 29.22 19.37 27.67C19.37 26.11 20.32 24.96 21.82 24.96C23.31 24.96 24.27 26.11 24.27 27.67ZM27.1465 32.84V30.27C27.5365 30.81 28.1165 31.12 28.7765 31.12C30.0465 31.12 30.9265 30.14 30.9265 28.58C30.9265 27.01 30.0465 26.05 28.7765 26.05C28.0965 26.05 27.4965 26.4 27.1465 26.89V26.17H26.3965V32.84H27.1465ZM30.1365 28.58C30.1365 29.65 29.5565 30.45 28.5865 30.45C27.9965 30.45 27.4065 30.09 27.1465 29.67V27.49C27.4065 27.07 27.9965 26.72 28.5865 26.72C29.5565 26.72 30.1365 27.51 30.1365 28.58ZM33.3587 31.12C33.7987 31.12 34.0687 30.99 34.2587 30.81L34.0387 30.25C33.9387 30.36 33.7387 30.45 33.5287 30.45C33.1987 30.45 33.0387 30.19 33.0387 29.83V26.83H34.0187V26.17H33.0387V24.85H32.2887V26.17H31.4887V26.83H32.2887V29.99C32.2887 30.71 32.6487 31.12 33.3587 31.12ZM35.4481 25.36C35.7281 25.36 35.9581 25.13 35.9581 24.85C35.9581 24.57 35.7281 24.35 35.4481 24.35C35.1781 24.35 34.9481 24.57 34.9481 24.85C34.9481 25.13 35.1781 25.36 35.4481 25.36ZM35.0781 31H35.8281V26.17H35.0781V31ZM39.4342 31.12C40.9042 31.12 41.8242 29.98 41.8242 28.58C41.8242 27.18 40.9042 26.05 39.4342 26.05C37.9642 26.05 37.0442 27.18 37.0442 28.58C37.0442 29.98 37.9642 31.12 39.4342 31.12ZM39.4342 30.45C38.4042 30.45 37.8242 29.57 37.8242 28.58C37.8242 27.6 38.4042 26.72 39.4342 26.72C40.4642 26.72 41.0342 27.6 41.0342 28.58C41.0342 29.57 40.4642 30.45 39.4342 30.45ZM46.3069 31H47.0569V27.61C47.0569 26.56 46.5269 26.05 45.5169 26.05C44.7969 26.05 44.1369 26.47 43.7969 26.87V26.17H43.0469V31H43.7969V27.47C44.0769 27.08 44.6369 26.72 45.2269 26.72C45.8769 26.72 46.3069 26.99 46.3069 27.84V31ZM51.1628 31H54.2028C55.4228 31 56.1328 30.27 56.1328 29.2C56.1328 28.4 55.5428 27.67 54.8328 27.56C55.4428 27.43 56.0028 26.87 56.0028 26.03C56.0028 25.03 55.2928 24.33 54.1328 24.33H51.1628V31ZM51.9928 27.22V25.07H53.9928C54.7428 25.07 55.1428 25.55 55.1428 26.15C55.1428 26.76 54.7428 27.22 53.9928 27.22H51.9928ZM51.9928 30.26V27.96H54.0328C54.8528 27.96 55.2728 28.5 55.2728 29.11C55.2728 29.82 54.8128 30.26 54.0328 30.26H51.9928Z"
      fill={gray['gray-800']}
    />
  </svg>
);

export const date = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M90.8125 6.25H89.875V5.15625C89.875 5.07031 89.8047 5 89.7188 5H89.4062C89.3203 5 89.25 5.07031 89.25 5.15625V6.25H85.5V5.15625C85.5 5.07031 85.4297 5 85.3438 5H85.0312C84.9453 5 84.875 5.07031 84.875 5.15625V6.25H83.9375C83.4199 6.25 83 6.66992 83 7.1875V14.0625C83 14.5801 83.4199 15 83.9375 15H90.8125C91.3301 15 91.75 14.5801 91.75 14.0625V7.1875C91.75 6.66992 91.3301 6.25 90.8125 6.25ZM91.125 14.0625C91.125 14.2344 90.9844 14.375 90.8125 14.375H83.9375C83.7656 14.375 83.625 14.2344 83.625 14.0625V8.75H91.125V14.0625ZM91.125 8.125H83.625V7.1875C83.625 7.01562 83.7656 6.875 83.9375 6.875H90.8125C90.9844 6.875 91.125 7.01562 91.125 7.1875V8.125ZM85.1875 12.5H87.0625C87.2344 12.5 87.375 12.3594 87.375 12.1875V10.3125C87.375 10.1406 87.2344 10 87.0625 10H85.1875C85.0156 10 84.875 10.1406 84.875 10.3125V12.1875C84.875 12.3594 85.0156 12.5 85.1875 12.5ZM85.5 10.625H86.75V11.875H85.5V10.625Z"
      fill={gray['gray-600']}
    />
    <path
      d="M12.48 13H13.31V6.33H12.12L10.04 11.41L7.97 6.33H6.78V13H7.61V7.45L9.87 13H10.21L12.48 7.45V13ZM20.5659 13H21.3959V6.33H20.2059L18.1259 11.41L16.0559 6.33H14.8659V13H15.6959V7.45L17.9559 13H18.2959L20.5659 7.45V13ZM22.1719 13.2H22.7619L25.1319 6.13H24.5419L22.1719 13.2ZM25.9109 13H28.1909C30.2609 13 31.6109 11.57 31.6109 9.67C31.6109 7.78 30.2609 6.33 28.1909 6.33H25.9109V13ZM26.7409 12.26V7.07H28.1909C29.8409 7.07 30.7509 8.23 30.7509 9.67C30.7509 11.1 29.8109 12.26 28.1909 12.26H26.7409ZM32.9128 13H35.1928C37.2628 13 38.6128 11.57 38.6128 9.67C38.6128 7.78 37.2628 6.33 35.1928 6.33H32.9128V13ZM33.7428 12.26V7.07H35.1928C36.8428 7.07 37.7528 8.23 37.7528 9.67C37.7528 11.1 36.8128 12.26 35.1928 12.26H33.7428ZM39.1348 13.2H39.7248L42.0948 6.13H41.5048L39.1348 13.2ZM44.8138 13H45.6438V10.18L48.2638 6.33H47.2938L45.2238 9.43L43.1538 6.33H42.1838L44.8138 10.18V13ZM51.0735 13H51.9035V10.18L54.5235 6.33H53.5535L51.4835 9.43L49.4135 6.33H48.4435L51.0735 10.18V13ZM57.3333 13H58.1633V10.18L60.7833 6.33H59.8133L57.7433 9.43L55.6733 6.33H54.7033L57.3333 10.18V13ZM63.593 13H64.423V10.18L67.043 6.33H66.073L64.003 9.43L61.933 6.33H60.963L63.593 10.18V13Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const dropdown = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M8.91 13.12C10.12 13.12 10.92 12.56 11.48 11.8L10.77 11.41C10.39 11.98 9.7 12.38 8.91 12.38C7.48 12.38 6.37 11.25 6.37 9.67C6.37 8.08 7.48 6.96 8.91 6.96C9.7 6.96 10.39 7.37 10.77 7.93L11.47 7.54C10.94 6.79 10.12 6.22 8.91 6.22C7.02 6.22 5.51 7.62 5.51 9.67C5.51 11.72 7.02 13.12 8.91 13.12ZM15.7778 13H16.5278V9.59C16.5278 8.54 15.9978 8.05 14.9878 8.05C14.2578 8.05 13.5978 8.47 13.2578 8.87V6.33H12.5078V13H13.2578V9.47C13.5478 9.08 14.1078 8.72 14.6878 8.72C15.3378 8.72 15.7778 8.97 15.7778 9.82V13ZM20.1354 13.12C21.6054 13.12 22.5254 11.98 22.5254 10.58C22.5254 9.18 21.6054 8.05 20.1354 8.05C18.6654 8.05 17.7454 9.18 17.7454 10.58C17.7454 11.98 18.6654 13.12 20.1354 13.12ZM20.1354 12.45C19.1054 12.45 18.5254 11.57 18.5254 10.58C18.5254 9.6 19.1054 8.72 20.1354 8.72C21.1654 8.72 21.7354 9.6 21.7354 10.58C21.7354 11.57 21.1654 12.45 20.1354 12.45ZM25.858 13.12C27.328 13.12 28.248 11.98 28.248 10.58C28.248 9.18 27.328 8.05 25.858 8.05C24.388 8.05 23.468 9.18 23.468 10.58C23.468 11.98 24.388 13.12 25.858 13.12ZM25.858 12.45C24.828 12.45 24.248 11.57 24.248 10.58C24.248 9.6 24.828 8.72 25.858 8.72C26.888 8.72 27.458 9.6 27.458 10.58C27.458 11.57 26.888 12.45 25.858 12.45ZM29.0507 12.36C29.5407 12.88 30.2107 13.12 31.0007 13.12C32.2507 13.12 32.9007 12.47 32.9007 11.66C32.9007 10.59 31.9307 10.35 31.0907 10.16C30.4607 10.01 29.9107 9.86 29.9107 9.39C29.9107 8.96 30.3207 8.66 30.9807 8.66C31.6007 8.66 32.1307 8.92 32.4207 9.27L32.7707 8.75C32.3807 8.36 31.8007 8.05 30.9807 8.05C29.8307 8.05 29.1807 8.69 29.1807 9.44C29.1807 10.44 30.1107 10.66 30.9307 10.85C31.5807 11.01 32.1707 11.18 32.1707 11.71C32.1707 12.18 31.7707 12.51 31.0307 12.51C30.3707 12.51 29.7607 12.19 29.4407 11.82L29.0507 12.36ZM33.8391 10.58C33.8391 12.09 34.8691 13.12 36.2991 13.12C37.0891 13.12 37.7391 12.86 38.2191 12.38L37.8591 11.89C37.4791 12.28 36.9191 12.5 36.3691 12.5C35.3291 12.5 34.6891 11.74 34.6291 10.83H38.5391V10.64C38.5391 9.19 37.6791 8.05 36.2191 8.05C34.8391 8.05 33.8391 9.18 33.8391 10.58ZM36.2091 8.67C37.3091 8.67 37.7891 9.56 37.7991 10.28H34.6291C34.6691 9.54 35.1791 8.67 36.2091 8.67ZM42.092 9.67C42.092 11.64 43.422 13.12 45.402 13.12C47.372 13.12 48.712 11.64 48.712 9.67C48.712 7.7 47.372 6.22 45.402 6.22C43.422 6.22 42.092 7.7 42.092 9.67ZM47.852 9.67C47.852 11.22 46.892 12.38 45.402 12.38C43.902 12.38 42.952 11.22 42.952 9.67C42.952 8.11 43.902 6.96 45.402 6.96C46.892 6.96 47.852 8.11 47.852 9.67ZM50.7285 14.84V12.27C51.1185 12.81 51.6985 13.12 52.3585 13.12C53.6285 13.12 54.5085 12.14 54.5085 10.58C54.5085 9.01 53.6285 8.05 52.3585 8.05C51.6785 8.05 51.0785 8.4 50.7285 8.89V8.17H49.9785V14.84H50.7285ZM53.7185 10.58C53.7185 11.65 53.1385 12.45 52.1685 12.45C51.5785 12.45 50.9885 12.09 50.7285 11.67V9.49C50.9885 9.07 51.5785 8.72 52.1685 8.72C53.1385 8.72 53.7185 9.51 53.7185 10.58ZM56.9407 13.12C57.3807 13.12 57.6507 12.99 57.8407 12.81L57.6207 12.25C57.5207 12.36 57.3207 12.45 57.1107 12.45C56.7807 12.45 56.6207 12.19 56.6207 11.83V8.83H57.6007V8.17H56.6207V6.85H55.8707V8.17H55.0707V8.83H55.8707V11.99C55.8707 12.71 56.2307 13.12 56.9407 13.12ZM59.0302 7.36C59.3102 7.36 59.5402 7.13 59.5402 6.85C59.5402 6.57 59.3102 6.35 59.0302 6.35C58.7602 6.35 58.5302 6.57 58.5302 6.85C58.5302 7.13 58.7602 7.36 59.0302 7.36ZM58.6602 13H59.4102V8.17H58.6602V13ZM63.0163 13.12C64.4863 13.12 65.4063 11.98 65.4063 10.58C65.4063 9.18 64.4863 8.05 63.0163 8.05C61.5463 8.05 60.6263 9.18 60.6263 10.58C60.6263 11.98 61.5463 13.12 63.0163 13.12ZM63.0163 12.45C61.9863 12.45 61.4062 11.57 61.4062 10.58C61.4062 9.6 61.9863 8.72 63.0163 8.72C64.0463 8.72 64.6163 9.6 64.6163 10.58C64.6163 11.57 64.0463 12.45 63.0163 12.45ZM69.8889 13H70.6389V9.61C70.6389 8.56 70.1089 8.05 69.0989 8.05C68.3789 8.05 67.7189 8.47 67.3789 8.87V8.17H66.6289V13H67.3789V9.47C67.6589 9.08 68.2189 8.72 68.8089 8.72C69.4589 8.72 69.8889 8.99 69.8889 9.84V13Z"
      fill={gray['gray-600']}
    />
    <path
      d="M87.7875 12.6774L84.0881 9.00797C83.9706 8.89049 83.9706 8.70052 84.0881 8.58303L84.583 8.08811C84.7005 7.97063 84.8905 7.97063 85.008 8.08811L88 11.0501L90.992 8.08811C91.1095 7.97063 91.2995 7.97063 91.417 8.08811L91.9119 8.58303C92.0294 8.70052 92.0294 8.89049 91.9119 9.00797L88.2125 12.6774C88.095 12.7949 87.905 12.7949 87.7875 12.6774Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const dynamicTags = () => (
  <svg
    width="98"
    height="40"
    viewBox="0 0 98 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="39.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M4.25 6C4.25 5.0335 5.0335 4.25 6 4.25H45C45.9665 4.25 46.75 5.0335 46.75 6V20C46.75 20.9665 45.9665 21.75 45 21.75H6C5.0335 21.75 4.25 20.9665 4.25 20V6Z"
      fill="white"
      stroke={gray['gray-500']}
      strokeWidth="0.5"
    />
    <path
      d="M12.43 16H13.26V10.07H15.38V9.33H10.32V10.07H12.43V16ZM18.5259 16H19.2759V12.68C19.2759 11.51 18.4259 11.05 17.4059 11.05C16.6159 11.05 15.9959 11.31 15.4759 11.85L15.8259 12.37C16.2559 11.91 16.7259 11.7 17.3059 11.7C18.0059 11.7 18.5259 12.07 18.5259 12.72V13.59C18.1359 13.14 17.5859 12.93 16.9259 12.93C16.1059 12.93 15.2359 13.44 15.2359 14.52C15.2359 15.57 16.1059 16.12 16.9259 16.12C17.5759 16.12 18.1259 15.89 18.5259 15.45V16ZM18.5259 14.98C18.2359 15.38 17.7259 15.58 17.1959 15.58C16.4959 15.58 16.0059 15.14 16.0059 14.53C16.0059 13.91 16.4959 13.47 17.1959 13.47C17.7259 13.47 18.2359 13.67 18.5259 14.07V14.98ZM20.7693 17.24C21.3393 17.8 21.8993 17.96 22.7193 17.96C23.8993 17.96 25.0193 17.46 25.0193 15.86V11.17H24.2693V11.9C23.8793 11.37 23.2993 11.05 22.6493 11.05C21.3793 11.05 20.4993 12.01 20.4993 13.56C20.4993 15.12 21.3893 16.06 22.6493 16.06C23.3293 16.06 23.9193 15.69 24.2693 15.2V15.89C24.2693 16.95 23.5193 17.34 22.7193 17.34C22.0293 17.34 21.5493 17.16 21.1493 16.68L20.7693 17.24ZM24.2693 14.61C24.0093 15.03 23.4293 15.4 22.8293 15.4C21.8593 15.4 21.2793 14.62 21.2793 13.56C21.2793 12.49 21.8593 11.72 22.8293 11.72C23.4293 11.72 24.0093 12.08 24.2693 12.5V14.61ZM33.9196 16H34.8396L32.1496 9.33H31.1196L28.4396 16H29.3596L29.9496 14.52H33.3296L33.9196 16ZM31.6396 10.07L33.0796 13.78H30.1896L31.6396 10.07Z"
      fill={gray['gray-800']}
    />
    <path
      d="M6 4C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22V4Z"
      fill={blue['blue-500']}
    />
    <path
      d="M51.25 6C51.25 5.0335 52.0335 4.25 53 4.25H92C92.9665 4.25 93.75 5.0335 93.75 6V20C93.75 20.9665 92.9665 21.75 92 21.75H53C52.0335 21.75 51.25 20.9665 51.25 20V6Z"
      fill="white"
      stroke={gray['gray-500']}
      strokeWidth="0.5"
    />
    <path
      d="M59.43 16H60.26V10.07H62.38V9.33H57.32V10.07H59.43V16ZM65.5259 16H66.2759V12.68C66.2759 11.51 65.4259 11.05 64.4059 11.05C63.6159 11.05 62.9959 11.31 62.4759 11.85L62.8259 12.37C63.2559 11.91 63.7259 11.7 64.3059 11.7C65.0059 11.7 65.5259 12.07 65.5259 12.72V13.59C65.1359 13.14 64.5859 12.93 63.9259 12.93C63.1059 12.93 62.2359 13.44 62.2359 14.52C62.2359 15.57 63.1059 16.12 63.9259 16.12C64.5759 16.12 65.1259 15.89 65.5259 15.45V16ZM65.5259 14.98C65.2359 15.38 64.7259 15.58 64.1959 15.58C63.4959 15.58 63.0059 15.14 63.0059 14.53C63.0059 13.91 63.4959 13.47 64.1959 13.47C64.7259 13.47 65.2359 13.67 65.5259 14.07V14.98ZM67.7693 17.24C68.3393 17.8 68.8993 17.96 69.7193 17.96C70.8993 17.96 72.0193 17.46 72.0193 15.86V11.17H71.2693V11.9C70.8793 11.37 70.2993 11.05 69.6493 11.05C68.3793 11.05 67.4993 12.01 67.4993 13.56C67.4993 15.12 68.3893 16.06 69.6493 16.06C70.3293 16.06 70.9193 15.69 71.2693 15.2V15.89C71.2693 16.95 70.5193 17.34 69.7193 17.34C69.0293 17.34 68.5493 17.16 68.1493 16.68L67.7693 17.24ZM71.2693 14.61C71.0093 15.03 70.4293 15.4 69.8293 15.4C68.8593 15.4 68.2793 14.62 68.2793 13.56C68.2793 12.49 68.8593 11.72 69.8293 11.72C70.4293 11.72 71.0093 12.08 71.2693 12.5V14.61ZM76.1296 16H79.1696C80.3896 16 81.0996 15.27 81.0996 14.2C81.0996 13.4 80.5096 12.67 79.7996 12.56C80.4096 12.43 80.9696 11.87 80.9696 11.03C80.9696 10.03 80.2596 9.33 79.0996 9.33H76.1296V16ZM76.9596 12.22V10.07H78.9596C79.7096 10.07 80.1096 10.55 80.1096 11.15C80.1096 11.76 79.7096 12.22 78.9596 12.22H76.9596ZM76.9596 15.26V12.96H78.9996C79.8196 12.96 80.2396 13.5 80.2396 14.11C80.2396 14.82 79.7796 15.26 78.9996 15.26H76.9596Z"
      fill={gray['gray-800']}
    />
    <path
      d="M53 4C51.8954 4 51 4.89543 51 6V20C51 21.1046 51.8954 22 53 22V4Z"
      fill={blue['blue-500']}
    />
    <path
      d="M5.78 34H6.61V30.96H10.08V30.22H6.61V28.07H10.15V27.33H5.78V34ZM11.618 28.36C11.898 28.36 12.128 28.13 12.128 27.85C12.128 27.57 11.898 27.35 11.618 27.35C11.348 27.35 11.118 27.57 11.118 27.85C11.118 28.13 11.348 28.36 11.618 28.36ZM11.248 34H11.998V29.17H11.248V34ZM16.7541 34H17.5041V30.61C17.5041 29.56 16.9741 29.05 15.9641 29.05C15.2441 29.05 14.5841 29.47 14.2441 29.87V29.17H13.4941V34H14.2441V30.47C14.5241 30.08 15.0841 29.72 15.6741 29.72C16.3241 29.72 16.7541 29.99 16.7541 30.84V34ZM22.502 34H23.252V27.33H22.502V29.9C22.112 29.37 21.522 29.05 20.872 29.05C19.602 29.05 18.722 30.05 18.722 31.59C18.722 33.16 19.612 34.12 20.872 34.12C21.552 34.12 22.142 33.77 22.502 33.28V34ZM22.502 32.69C22.232 33.11 21.652 33.45 21.052 33.45C20.082 33.45 19.502 32.66 19.502 31.59C19.502 30.52 20.082 29.72 21.052 29.72C21.652 29.72 22.232 30.08 22.502 30.5V32.69ZM29.012 34H29.842V28.07H31.962V27.33H26.902V28.07H29.012V34ZM35.1079 34H35.8579V30.68C35.8579 29.51 35.0079 29.05 33.9879 29.05C33.1979 29.05 32.5779 29.31 32.0579 29.85L32.4079 30.37C32.8379 29.91 33.3079 29.7 33.8879 29.7C34.5879 29.7 35.1079 30.07 35.1079 30.72V31.59C34.7179 31.14 34.1679 30.93 33.5079 30.93C32.6879 30.93 31.8179 31.44 31.8179 32.52C31.8179 33.57 32.6879 34.12 33.5079 34.12C34.1579 34.12 34.7079 33.89 35.1079 33.45V34ZM35.1079 32.98C34.8179 33.38 34.3079 33.58 33.7779 33.58C33.0779 33.58 32.5879 33.14 32.5879 32.53C32.5879 31.91 33.0779 31.47 33.7779 31.47C34.3079 31.47 34.8179 31.67 35.1079 32.07V32.98ZM37.3513 35.24C37.9213 35.8 38.4813 35.96 39.3013 35.96C40.4813 35.96 41.6013 35.46 41.6013 33.86V29.17H40.8513V29.9C40.4613 29.37 39.8813 29.05 39.2313 29.05C37.9613 29.05 37.0813 30.01 37.0813 31.56C37.0813 33.12 37.9713 34.06 39.2313 34.06C39.9113 34.06 40.5013 33.69 40.8513 33.2V33.89C40.8513 34.95 40.1013 35.34 39.3013 35.34C38.6113 35.34 38.1313 35.16 37.7313 34.68L37.3513 35.24ZM40.8513 32.61C40.5913 33.03 40.0113 33.4 39.4113 33.4C38.4413 33.4 37.8613 32.62 37.8613 31.56C37.8613 30.49 38.4413 29.72 39.4113 29.72C40.0113 29.72 40.5913 30.08 40.8513 30.5V32.61ZM42.6835 33.36C43.1735 33.88 43.8435 34.12 44.6335 34.12C45.8835 34.12 46.5335 33.47 46.5335 32.66C46.5335 31.59 45.5635 31.35 44.7235 31.16C44.0935 31.01 43.5435 30.86 43.5435 30.39C43.5435 29.96 43.9535 29.66 44.6135 29.66C45.2335 29.66 45.7635 29.92 46.0535 30.27L46.4035 29.75C46.0135 29.36 45.4335 29.05 44.6135 29.05C43.4635 29.05 42.8135 29.69 42.8135 30.44C42.8135 31.44 43.7435 31.66 44.5635 31.85C45.2135 32.01 45.8035 32.18 45.8035 32.71C45.8035 33.18 45.4035 33.51 44.6635 33.51C44.0035 33.51 43.3935 33.19 43.0735 32.82L42.6835 33.36Z"
      fill={gray['gray-600']}
    />
    <path
      d="M92.9449 34.3262L91.0481 32.4294C91.0122 32.3935 90.9653 32.3747 90.9153 32.3747H90.7091C91.2013 31.8045 91.4997 31.0623 91.4997 30.2498C91.4997 28.4546 90.0451 27 88.2498 27C86.4546 27 85 28.4546 85 30.2498C85 32.0451 86.4546 33.4997 88.2498 33.4997C89.0623 33.4997 89.8045 33.2013 90.3747 32.7091V32.9153C90.3747 32.9653 90.395 33.0122 90.4294 33.0481L92.3262 34.9449C92.3996 35.0184 92.5184 35.0184 92.5918 34.9449L92.9449 34.5918C93.0184 34.5184 93.0184 34.3996 92.9449 34.3262ZM88.2498 32.7497C86.8687 32.7497 85.75 31.631 85.75 30.2498C85.75 28.8687 86.8687 27.75 88.2498 27.75C89.631 27.75 90.7497 28.8687 90.7497 30.2498C90.7497 31.631 89.631 32.7497 88.2498 32.7497Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const emailAddress = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M6.47 10.58C6.47 12.09 7.5 13.12 8.93 13.12C9.72 13.12 10.37 12.86 10.85 12.38L10.49 11.89C10.11 12.28 9.55 12.5 9 12.5C7.96 12.5 7.32 11.74 7.26 10.83H11.17V10.64C11.17 9.19 10.31 8.05 8.85 8.05C7.47 8.05 6.47 9.18 6.47 10.58ZM8.84 8.67C9.94 8.67 10.42 9.56 10.43 10.28H7.26C7.3 9.54 7.81 8.67 8.84 8.67ZM18.2148 13H18.9648V9.51C18.9648 8.54 18.4948 8.05 17.6148 8.05C16.9148 8.05 16.2648 8.51 15.9948 8.95C15.8548 8.45 15.4348 8.05 14.6948 8.05C13.9848 8.05 13.3348 8.56 13.1348 8.87V8.17H12.3848V13H13.1348V9.47C13.3948 9.08 13.9148 8.72 14.4048 8.72C15.0348 8.72 15.2948 9.11 15.2948 9.72V13H16.0448V9.46C16.2948 9.08 16.8248 8.72 17.3248 8.72C17.9448 8.72 18.2148 9.11 18.2148 9.72V13ZM23.4809 13H24.2309V9.68C24.2309 8.51 23.3809 8.05 22.3609 8.05C21.5709 8.05 20.9509 8.31 20.4309 8.85L20.7809 9.37C21.2109 8.91 21.6809 8.7 22.2609 8.7C22.9609 8.7 23.4809 9.07 23.4809 9.72V10.59C23.0909 10.14 22.5409 9.93 21.8809 9.93C21.0609 9.93 20.1909 10.44 20.1909 11.52C20.1909 12.57 21.0609 13.12 21.8809 13.12C22.5309 13.12 23.0809 12.89 23.4809 12.45V13ZM23.4809 11.98C23.1909 12.38 22.6809 12.58 22.1509 12.58C21.4509 12.58 20.9609 12.14 20.9609 11.53C20.9609 10.91 21.4509 10.47 22.1509 10.47C22.6809 10.47 23.1909 10.67 23.4809 11.07V11.98ZM26.1044 7.36C26.3844 7.36 26.6144 7.13 26.6144 6.85C26.6144 6.57 26.3844 6.35 26.1044 6.35C25.8344 6.35 25.6044 6.57 25.6044 6.85C25.6044 7.13 25.8344 7.36 26.1044 7.36ZM25.7344 13H26.4844V8.17H25.7344V13ZM27.9805 13H28.7305V6.33H27.9805V13ZM29.8266 10.56C29.8266 12.33 31.1766 13.7 32.9966 13.7C33.7366 13.7 34.4566 13.47 35.0766 13.07L34.8966 12.81C34.3566 13.15 33.7466 13.37 33.0366 13.37C31.3766 13.37 30.1666 12.15 30.1666 10.54C30.1666 8.67 31.8266 6.96 33.7566 6.96C35.4566 6.96 36.5866 8.15 36.5866 9.79C36.5866 11.17 35.8966 11.61 35.5066 11.61C35.2466 11.61 35.0366 11.43 35.0366 11.09C35.0366 11.03 35.0466 10.94 35.0566 10.88L35.6266 8.17H34.9466L34.8166 8.79C34.6266 8.36 34.1866 8.01 33.5366 8.01C32.3566 8.01 31.1866 9.13 31.1866 10.52C31.1866 11.49 31.7866 12.15 32.7166 12.15C33.3566 12.15 33.9466 11.77 34.2966 11.28L34.3066 11.34C34.3366 11.76 34.6566 12.15 35.2166 12.15C36.0566 12.15 36.9466 11.36 36.9466 9.79C36.9466 8.04 35.6866 6.62 33.7966 6.62C31.7166 6.62 29.8266 8.4 29.8266 10.56ZM34.4066 10.69C34.1166 11.11 33.6066 11.59 32.9166 11.59C32.2766 11.59 31.8966 11.12 31.8966 10.48C31.8966 9.52 32.6666 8.57 33.6666 8.57C34.2566 8.57 34.5866 9 34.6966 9.31L34.4066 10.69ZM41.5586 13H42.3086V6.33H41.5586V8.9C41.1686 8.37 40.5786 8.05 39.9286 8.05C38.6586 8.05 37.7786 9.05 37.7786 10.59C37.7786 12.16 38.6686 13.12 39.9286 13.12C40.6086 13.12 41.1986 12.77 41.5586 12.28V13ZM41.5586 11.69C41.2886 12.11 40.7086 12.45 40.1086 12.45C39.1386 12.45 38.5586 11.66 38.5586 10.59C38.5586 9.52 39.1386 8.72 40.1086 8.72C40.7086 8.72 41.2886 9.08 41.5586 9.5V11.69ZM45.9205 13.12C47.3905 13.12 48.3105 11.98 48.3105 10.58C48.3105 9.18 47.3905 8.05 45.9205 8.05C44.4505 8.05 43.5305 9.18 43.5305 10.58C43.5305 11.98 44.4505 13.12 45.9205 13.12ZM45.9205 12.45C44.8905 12.45 44.3105 11.57 44.3105 10.58C44.3105 9.6 44.8905 8.72 45.9205 8.72C46.9505 8.72 47.5205 9.6 47.5205 10.58C47.5205 11.57 46.9505 12.45 45.9205 12.45ZM55.3632 13H56.1132V9.51C56.1132 8.54 55.6432 8.05 54.7632 8.05C54.0632 8.05 53.4132 8.51 53.1432 8.95C53.0032 8.45 52.5832 8.05 51.8432 8.05C51.1332 8.05 50.4832 8.56 50.2832 8.87V8.17H49.5332V13H50.2832V9.47C50.5432 9.08 51.0632 8.72 51.5532 8.72C52.1832 8.72 52.4432 9.11 52.4432 9.72V13H53.1932V9.46C53.4432 9.08 53.9732 8.72 54.4732 8.72C55.0932 8.72 55.3632 9.11 55.3632 9.72V13ZM60.6294 13H61.3794V9.68C61.3794 8.51 60.5294 8.05 59.5094 8.05C58.7194 8.05 58.0994 8.31 57.5794 8.85L57.9294 9.37C58.3594 8.91 58.8294 8.7 59.4094 8.7C60.1094 8.7 60.6294 9.07 60.6294 9.72V10.59C60.2394 10.14 59.6894 9.93 59.0294 9.93C58.2094 9.93 57.3394 10.44 57.3394 11.52C57.3394 12.57 58.2094 13.12 59.0294 13.12C59.6794 13.12 60.2294 12.89 60.6294 12.45V13ZM60.6294 11.98C60.3394 12.38 59.8294 12.58 59.2994 12.58C58.5994 12.58 58.1094 12.14 58.1094 11.53C58.1094 10.91 58.5994 10.47 59.2994 10.47C59.8294 10.47 60.3394 10.67 60.6294 11.07V11.98ZM63.2528 7.36C63.5328 7.36 63.7628 7.13 63.7628 6.85C63.7628 6.57 63.5328 6.35 63.2528 6.35C62.9828 6.35 62.7528 6.57 62.7528 6.85C62.7528 7.13 62.9828 7.36 63.2528 7.36ZM62.8828 13H63.6328V8.17H62.8828V13ZM68.3889 13H69.1389V9.61C69.1389 8.56 68.6089 8.05 67.5989 8.05C66.8789 8.05 66.2189 8.47 65.8789 8.87V8.17H65.1289V13H65.8789V9.47C66.1589 9.08 66.7189 8.72 67.3089 8.72C67.9589 8.72 68.3889 8.99 68.3889 9.84V13ZM70.4867 12.55C70.4867 12.85 70.7367 13.1 71.0367 13.1C71.3367 13.1 71.5867 12.85 71.5867 12.55C71.5867 12.25 71.3367 12 71.0367 12C70.7367 12 70.4867 12.25 70.4867 12.55ZM72.593 10.58C72.593 12.02 73.563 13.12 75.003 13.12C75.883 13.12 76.403 12.76 76.773 12.28L76.273 11.82C75.953 12.25 75.543 12.45 75.043 12.45C74.013 12.45 73.373 11.65 73.373 10.58C73.373 9.51 74.013 8.72 75.043 8.72C75.543 8.72 75.953 8.91 76.273 9.35L76.773 8.89C76.403 8.41 75.883 8.05 75.003 8.05C73.563 8.05 72.593 9.15 72.593 10.58ZM79.9342 13.12C81.4042 13.12 82.3242 11.98 82.3242 10.58C82.3242 9.18 81.4042 8.05 79.9342 8.05C78.4642 8.05 77.5442 9.18 77.5442 10.58C77.5442 11.98 78.4642 13.12 79.9342 13.12ZM79.9342 12.45C78.9042 12.45 78.3242 11.57 78.3242 10.58C78.3242 9.6 78.9042 8.72 79.9342 8.72C80.9642 8.72 81.5342 9.6 81.5342 10.58C81.5342 11.57 80.9642 12.45 79.9342 12.45ZM89.3769 13H90.1269V9.51C90.1269 8.54 89.6569 8.05 88.7769 8.05C88.0769 8.05 87.4269 8.51 87.1569 8.95C87.0169 8.45 86.5969 8.05 85.8569 8.05C85.1469 8.05 84.4969 8.56 84.2969 8.87V8.17H83.5469V13H84.2969V9.47C84.5569 9.08 85.0769 8.72 85.5669 8.72C86.1969 8.72 86.4569 9.11 86.4569 9.72V13H87.2069V9.46C87.4569 9.08 87.9869 8.72 88.4869 8.72C89.1069 8.72 89.3769 9.11 89.3769 9.72V13Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const files = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
      strokeDasharray="4 4"
    />
    <path
      d="M10.57 13H11.49L8.8 6.33H7.77L5.09 13H6.01L6.6 11.52H9.98L10.57 13ZM8.29 7.07L9.73 10.78H6.84L8.29 7.07ZM15.832 13H16.582V6.33H15.832V8.9C15.442 8.37 14.852 8.05 14.202 8.05C12.932 8.05 12.052 9.05 12.052 10.59C12.052 12.16 12.942 13.12 14.202 13.12C14.882 13.12 15.472 12.77 15.832 12.28V13ZM15.832 11.69C15.562 12.11 14.982 12.45 14.382 12.45C13.412 12.45 12.832 11.66 12.832 10.59C12.832 9.52 13.412 8.72 14.382 8.72C14.982 8.72 15.562 9.08 15.832 9.5V11.69ZM21.584 13H22.334V6.33H21.584V8.9C21.194 8.37 20.604 8.05 19.954 8.05C18.684 8.05 17.804 9.05 17.804 10.59C17.804 12.16 18.694 13.12 19.954 13.12C20.634 13.12 21.224 12.77 21.584 12.28V13ZM21.584 11.69C21.314 12.11 20.734 12.45 20.134 12.45C19.164 12.45 18.584 11.66 18.584 10.59C18.584 9.52 19.164 8.72 20.134 8.72C20.734 8.72 21.314 9.08 21.584 9.5V11.69ZM26.4441 13H27.2741V9.96H30.7441V9.22H27.2741V7.07H30.8141V6.33H26.4441V13ZM32.2821 7.36C32.5621 7.36 32.7921 7.13 32.7921 6.85C32.7921 6.57 32.5621 6.35 32.2821 6.35C32.0121 6.35 31.7821 6.57 31.7821 6.85C31.7821 7.13 32.0121 7.36 32.2821 7.36ZM31.9121 13H32.6621V8.17H31.9121V13ZM34.1582 13H34.9082V6.33H34.1582V13ZM36.1243 10.58C36.1243 12.09 37.1543 13.12 38.5843 13.12C39.3743 13.12 40.0243 12.86 40.5043 12.38L40.1443 11.89C39.7643 12.28 39.2043 12.5 38.6543 12.5C37.6143 12.5 36.9743 11.74 36.9143 10.83H40.8243V10.64C40.8243 9.19 39.9643 8.05 38.5043 8.05C37.1243 8.05 36.1243 9.18 36.1243 10.58ZM38.4943 8.67C39.5943 8.67 40.0743 9.56 40.0843 10.28H36.9143C36.9543 9.54 37.4643 8.67 38.4943 8.67ZM41.6191 12.36C42.1091 12.88 42.7791 13.12 43.5691 13.12C44.8191 13.12 45.4691 12.47 45.4691 11.66C45.4691 10.59 44.4991 10.35 43.6591 10.16C43.0291 10.01 42.4791 9.86 42.4791 9.39C42.4791 8.96 42.8891 8.66 43.5491 8.66C44.1691 8.66 44.6991 8.92 44.9891 9.27L45.3391 8.75C44.9491 8.36 44.3691 8.05 43.5491 8.05C42.3991 8.05 41.7491 8.69 41.7491 9.44C41.7491 10.44 42.6791 10.66 43.4991 10.85C44.1491 11.01 44.7391 11.18 44.7391 11.71C44.7391 12.18 44.3391 12.51 43.5991 12.51C42.9391 12.51 42.3291 12.19 42.0091 11.82L41.6191 12.36Z"
      fill={blue['blue-500']}
    />
  </svg>
);

export const longText = () => (
  <svg
    width="98"
    height="40"
    viewBox="0 0 98 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="39.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
  </svg>
);

export const numberDecimal = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M5.51 9.67C5.51 11.29 6.23 13.12 8.06 13.12C9.88 13.12 10.61 11.29 10.61 9.67C10.61 8.04 9.88 6.23 8.06 6.23C6.23 6.23 5.51 8.04 5.51 9.67ZM9.76 9.67C9.76 11 9.33 12.38 8.06 12.38C6.79 12.38 6.36 11 6.36 9.67C6.36 8.34 6.79 6.97 8.06 6.97C9.33 6.97 9.76 8.34 9.76 9.67ZM11.4105 12.55C11.4105 12.85 11.6605 13.1 11.9605 13.1C12.2605 13.1 12.5105 12.85 12.5105 12.55C12.5105 12.25 12.2605 12 11.9605 12C11.6605 12 11.4105 12.25 11.4105 12.55ZM13.6252 9.67C13.6252 11.29 14.3452 13.12 16.1752 13.12C17.9952 13.12 18.7252 11.29 18.7252 9.67C18.7252 8.04 17.9952 6.23 16.1752 6.23C14.3452 6.23 13.6252 8.04 13.6252 9.67ZM17.8752 9.67C17.8752 11 17.4452 12.38 16.1752 12.38C14.9052 12.38 14.4752 11 14.4752 9.67C14.4752 8.34 14.9052 6.97 16.1752 6.97C17.4452 6.97 17.8752 8.34 17.8752 9.67ZM19.7483 9.67C19.7483 11.29 20.4683 13.12 22.2983 13.12C24.1183 13.12 24.8483 11.29 24.8483 9.67C24.8483 8.04 24.1183 6.23 22.2983 6.23C20.4683 6.23 19.7483 8.04 19.7483 9.67ZM23.9983 9.67C23.9983 11 23.5683 12.38 22.2983 12.38C21.0283 12.38 20.5983 11 20.5983 9.67C20.5983 8.34 21.0283 6.97 22.2983 6.97C23.5683 6.97 23.9983 8.34 23.9983 9.67Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const numberWhole = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M6.51 9.67C6.51 11.29 7.23 13.12 9.06 13.12C10.88 13.12 11.61 11.29 11.61 9.67C11.61 8.04 10.88 6.23 9.06 6.23C7.23 6.23 6.51 8.04 6.51 9.67ZM10.76 9.67C10.76 11 10.33 12.38 9.06 12.38C7.79 12.38 7.36 11 7.36 9.67C7.36 8.34 7.79 6.97 9.06 6.97C10.33 6.97 10.76 8.34 10.76 9.67Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const phoneNumber = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M7.78 9.89H9.7V9.37H7.78V7.3H7.21V9.37H5.29V9.89H7.21V12.02H7.78V9.89ZM11.7702 13H12.6002V6.33H11.8702L10.2002 8.05L10.7002 8.56L11.7702 7.43V13ZM17.807 14.99L18.257 14.64C17.617 13.38 17.217 12.23 17.217 10.57C17.217 8.9 17.617 7.76 18.257 6.49L17.807 6.15C16.907 7.39 16.397 8.96 16.397 10.57C16.397 12.18 16.907 13.76 17.807 14.99ZM20.2175 13H21.0475V6.33H20.3175L18.6475 8.05L19.1475 8.56L20.2175 7.43V13ZM22.3662 13H26.9462V12.26H23.6762C25.5362 10.79 26.9162 9.55 26.9162 8.19C26.9162 6.86 25.7862 6.23 24.6762 6.23C23.7362 6.23 22.8662 6.61 22.3562 7.28L22.8662 7.81C23.2562 7.31 23.8762 6.97 24.6762 6.97C25.3662 6.97 26.0662 7.34 26.0662 8.19C26.0662 9.34 24.7662 10.45 22.3662 12.34V13ZM27.9951 12.02C28.4051 12.62 29.2351 13.12 30.3651 13.12C31.8351 13.12 32.7251 12.31 32.7251 11.2C32.7251 10.13 31.7951 9.61 31.1851 9.56C31.8151 9.45 32.6251 8.97 32.6251 8.01C32.6251 6.88 31.6451 6.23 30.3651 6.23C29.3351 6.23 28.5651 6.68 28.0851 7.26L28.5451 7.78C29.0351 7.25 29.5751 6.97 30.3051 6.97C31.1151 6.97 31.7951 7.37 31.7951 8.11C31.7951 8.88 31.0851 9.21 30.2451 9.21C29.9751 9.21 29.6651 9.21 29.5551 9.2V9.96C29.6551 9.95 29.9651 9.95 30.2451 9.95C31.2251 9.95 31.9051 10.3 31.9051 11.13C31.9051 11.9 31.3151 12.38 30.3451 12.38C29.5551 12.38 28.8751 12.02 28.4851 11.5L27.9951 12.02ZM34.4915 10.57C34.4915 12.23 34.0915 13.38 33.4415 14.64L33.8915 14.99C34.8015 13.76 35.3115 12.18 35.3115 10.57C35.3115 8.96 34.8015 7.39 33.8915 6.15L33.4415 6.49C34.0915 7.76 34.4915 8.9 34.4915 10.57ZM41.8201 13H42.6501V11.31H43.5901V10.58H42.6501V6.33H41.5101L38.6501 10.62V11.31H41.8201V13ZM41.8201 7.1V10.58H39.4801L41.8201 7.1ZM44.5662 12.05C45.0663 12.71 45.7863 13.12 46.9163 13.12C48.2563 13.12 49.2863 12.28 49.2863 10.92C49.2863 9.55 48.2763 8.79 47.1663 8.79C46.4963 8.79 45.9263 9.07 45.6063 9.39V7.07H48.8563V6.33H44.7763V9.93L45.3863 10.14C45.8363 9.7 46.3363 9.51 46.9263 9.51C47.8263 9.51 48.4563 10.07 48.4563 10.95C48.4563 11.76 47.8263 12.38 46.9163 12.38C46.0963 12.38 45.5163 12.06 45.0763 11.5L44.5662 12.05ZM50.3147 9.68C50.3147 11.49 51.0247 13.12 52.8847 13.12C54.3447 13.12 55.2247 12.1 55.2247 10.94C55.2247 9.52 54.2447 8.81 53.0447 8.81C52.1847 8.81 51.4447 9.39 51.1547 9.85C51.1447 9.76 51.1447 9.68 51.1447 9.59C51.1447 8.28 51.7347 6.97 53.0247 6.97C53.7247 6.97 54.1147 7.25 54.4547 7.65L54.8747 7.03C54.4647 6.56 53.8847 6.23 53.0247 6.23C51.1547 6.23 50.3147 7.87 50.3147 9.68ZM54.3847 10.97C54.3847 11.61 53.8847 12.38 52.8547 12.38C51.6947 12.38 51.2547 11.36 51.1747 10.53C51.5447 9.94 52.1847 9.53 52.8447 9.53C53.7047 9.53 54.3847 9.99 54.3847 10.97ZM56.0129 10.91H58.4129V10.25H56.0129V10.91ZM59.9209 13H60.8409L63.5709 6.9V6.33H59.0209V7.07H62.6109L59.9209 13ZM64.3774 11.31C64.3774 12.45 65.4474 13.12 66.7674 13.12C68.0774 13.12 69.1574 12.44 69.1574 11.31C69.1574 10.42 68.3974 9.81 67.5674 9.56C68.3374 9.34 69.0574 8.84 69.0574 7.96C69.0574 6.76 67.8674 6.23 66.7674 6.23C65.6574 6.23 64.4874 6.76 64.4874 7.96C64.4874 8.84 65.1974 9.34 65.9674 9.56C65.1374 9.81 64.3774 10.42 64.3774 11.31ZM68.2174 8.07C68.2174 8.88 67.1774 9.15 66.7674 9.22C66.3674 9.15 65.3174 8.88 65.3174 8.07C65.3174 7.38 65.9574 6.97 66.7674 6.97C67.5674 6.97 68.2174 7.38 68.2174 8.07ZM68.3174 11.22C68.3174 11.94 67.5874 12.38 66.7674 12.38C65.9374 12.38 65.2074 11.94 65.2074 11.22C65.2074 10.35 66.3574 9.98 66.7674 9.93C67.1774 9.98 68.3174 10.35 68.3174 11.22ZM70.508 12.31C70.928 12.79 71.508 13.11 72.358 13.11C74.228 13.11 75.068 11.47 75.068 9.67C75.068 7.85 74.358 6.22 72.488 6.22C71.038 6.22 70.158 7.25 70.158 8.4C70.158 9.82 71.148 10.53 72.348 10.53C73.198 10.53 73.938 9.95 74.228 9.49C74.238 9.58 74.238 9.67 74.238 9.76C74.238 11.02 73.708 12.37 72.358 12.37C71.668 12.37 71.268 12.09 70.928 11.69L70.508 12.31ZM74.198 8.82C73.848 9.41 73.198 9.81 72.538 9.81C71.678 9.81 70.998 9.35 70.998 8.37C70.998 7.74 71.508 6.96 72.528 6.96C73.688 6.96 74.128 7.99 74.198 8.82ZM76.0862 9.67C76.0862 11.29 76.8062 13.12 78.6362 13.12C80.4562 13.12 81.1862 11.29 81.1862 9.67C81.1862 8.04 80.4562 6.23 78.6362 6.23C76.8062 6.23 76.0862 8.04 76.0862 9.67ZM80.3362 9.67C80.3362 11 79.9062 12.38 78.6362 12.38C77.3662 12.38 76.9362 11 76.9362 9.67C76.9362 8.34 77.3662 6.97 78.6362 6.97C79.9062 6.97 80.3362 8.34 80.3362 9.67Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const price = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M10.44 11.16C10.44 9.85 9.35 9.47 8.32 9.18V7.01C8.88 7.09 9.4 7.33 9.79 7.77L10.29 7.16C9.81 6.65 9.15 6.32 8.32 6.25V5.32H7.71V6.23C6.51 6.31 5.63 7.04 5.63 8.08C5.63 9.31 6.69 9.66 7.71 9.93V12.36C6.92 12.28 6.31 11.87 5.92 11.43L5.42 12.06C5.92 12.63 6.69 13.05 7.71 13.11V14H8.32V13.1C9.87 12.99 10.44 12.06 10.44 11.16ZM6.49 8.03C6.49 7.44 6.99 7.02 7.71 6.98V9.02C7.04 8.83 6.49 8.6 6.49 8.03ZM8.32 12.35V10.09C9.01 10.3 9.59 10.55 9.59 11.23C9.59 11.69 9.28 12.27 8.32 12.35Z"
      fill={gray['gray-800']}
    />
    <path
      d="M14.0159 9.67C14.0159 11.29 14.7359 13.12 16.5659 13.12C18.3859 13.12 19.1159 11.29 19.1159 9.67C19.1159 8.04 18.3859 6.23 16.5659 6.23C14.7359 6.23 14.0159 8.04 14.0159 9.67ZM18.2659 9.67C18.2659 11 17.8359 12.38 16.5659 12.38C15.2959 12.38 14.8659 11 14.8659 9.67C14.8659 8.34 15.2959 6.97 16.5659 6.97C17.8359 6.97 18.2659 8.34 18.2659 9.67ZM19.9164 12.55C19.9164 12.85 20.1664 13.1 20.4664 13.1C20.7664 13.1 21.0164 12.85 21.0164 12.55C21.0164 12.25 20.7664 12 20.4664 12C20.1664 12 19.9164 12.25 19.9164 12.55ZM22.1311 9.67C22.1311 11.29 22.8511 13.12 24.6811 13.12C26.5011 13.12 27.2311 11.29 27.2311 9.67C27.2311 8.04 26.5011 6.23 24.6811 6.23C22.8511 6.23 22.1311 8.04 22.1311 9.67ZM26.3811 9.67C26.3811 11 25.9511 12.38 24.6811 12.38C23.4111 12.38 22.9811 11 22.9811 9.67C22.9811 8.34 23.4111 6.97 24.6811 6.97C25.9511 6.97 26.3811 8.34 26.3811 9.67ZM28.2541 9.67C28.2541 11.29 28.9741 13.12 30.8041 13.12C32.6241 13.12 33.3541 11.29 33.3541 9.67C33.3541 8.04 32.6241 6.23 30.8041 6.23C28.9741 6.23 28.2541 8.04 28.2541 9.67ZM32.5041 9.67C32.5041 11 32.0741 12.38 30.8041 12.38C29.5341 12.38 29.1041 11 29.1041 9.67C29.1041 8.34 29.5341 6.97 30.8041 6.97C32.0741 6.97 32.5041 8.34 32.5041 9.67Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const radioButtons = () => (
  <svg
    width="57"
    height="34"
    viewBox="0 0 57 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="22.25"
      width="11.5"
      height="11.5"
      rx="5.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <rect
      x="0.25"
      y="0.25"
      width="11.5"
      height="11.5"
      rx="5.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M18.51 5.67C18.51 7.64 19.84 9.12 21.82 9.12C23.79 9.12 25.13 7.64 25.13 5.67C25.13 3.7 23.79 2.22 21.82 2.22C19.84 2.22 18.51 3.7 18.51 5.67ZM24.27 5.67C24.27 7.22 23.31 8.38 21.82 8.38C20.32 8.38 19.37 7.22 19.37 5.67C19.37 4.11 20.32 2.96 21.82 2.96C23.31 2.96 24.27 4.11 24.27 5.67ZM27.1465 10.84V8.27C27.5365 8.81 28.1165 9.12 28.7765 9.12C30.0465 9.12 30.9265 8.14 30.9265 6.58C30.9265 5.01 30.0465 4.05 28.7765 4.05C28.0965 4.05 27.4965 4.4 27.1465 4.89V4.17H26.3965V10.84H27.1465ZM30.1365 6.58C30.1365 7.65 29.5565 8.45 28.5865 8.45C27.9965 8.45 27.4065 8.09 27.1465 7.67V5.49C27.4065 5.07 27.9965 4.72 28.5865 4.72C29.5565 4.72 30.1365 5.51 30.1365 6.58ZM33.3587 9.12C33.7987 9.12 34.0687 8.99 34.2587 8.81L34.0387 8.25C33.9387 8.36 33.7387 8.45 33.5287 8.45C33.1987 8.45 33.0387 8.19 33.0387 7.83V4.83H34.0187V4.17H33.0387V2.85H32.2887V4.17H31.4887V4.83H32.2887V7.99C32.2887 8.71 32.6487 9.12 33.3587 9.12ZM35.4481 3.36C35.7281 3.36 35.9581 3.13 35.9581 2.85C35.9581 2.57 35.7281 2.35 35.4481 2.35C35.1781 2.35 34.9481 2.57 34.9481 2.85C34.9481 3.13 35.1781 3.36 35.4481 3.36ZM35.0781 9H35.8281V4.17H35.0781V9ZM39.4342 9.12C40.9042 9.12 41.8242 7.98 41.8242 6.58C41.8242 5.18 40.9042 4.05 39.4342 4.05C37.9642 4.05 37.0442 5.18 37.0442 6.58C37.0442 7.98 37.9642 9.12 39.4342 9.12ZM39.4342 8.45C38.4042 8.45 37.8242 7.57 37.8242 6.58C37.8242 5.6 38.4042 4.72 39.4342 4.72C40.4642 4.72 41.0342 5.6 41.0342 6.58C41.0342 7.57 40.4642 8.45 39.4342 8.45ZM46.3069 9H47.0569V5.61C47.0569 4.56 46.5269 4.05 45.5169 4.05C44.7969 4.05 44.1369 4.47 43.7969 4.87V4.17H43.0469V9H43.7969V5.47C44.0769 5.08 44.6369 4.72 45.2269 4.72C45.8769 4.72 46.3069 4.99 46.3069 5.84V9ZM55.9528 9H56.8728L54.1828 2.33H53.1528L50.4728 9H51.3928L51.9828 7.52H55.3628L55.9528 9ZM53.6728 3.07L55.1128 6.78H52.2228L53.6728 3.07Z"
      fill={gray['gray-800']}
    />
    <path
      d="M18.51 27.67C18.51 29.64 19.84 31.12 21.82 31.12C23.79 31.12 25.13 29.64 25.13 27.67C25.13 25.7 23.79 24.22 21.82 24.22C19.84 24.22 18.51 25.7 18.51 27.67ZM24.27 27.67C24.27 29.22 23.31 30.38 21.82 30.38C20.32 30.38 19.37 29.22 19.37 27.67C19.37 26.11 20.32 24.96 21.82 24.96C23.31 24.96 24.27 26.11 24.27 27.67ZM27.1465 32.84V30.27C27.5365 30.81 28.1165 31.12 28.7765 31.12C30.0465 31.12 30.9265 30.14 30.9265 28.58C30.9265 27.01 30.0465 26.05 28.7765 26.05C28.0965 26.05 27.4965 26.4 27.1465 26.89V26.17H26.3965V32.84H27.1465ZM30.1365 28.58C30.1365 29.65 29.5565 30.45 28.5865 30.45C27.9965 30.45 27.4065 30.09 27.1465 29.67V27.49C27.4065 27.07 27.9965 26.72 28.5865 26.72C29.5565 26.72 30.1365 27.51 30.1365 28.58ZM33.3587 31.12C33.7987 31.12 34.0687 30.99 34.2587 30.81L34.0387 30.25C33.9387 30.36 33.7387 30.45 33.5287 30.45C33.1987 30.45 33.0387 30.19 33.0387 29.83V26.83H34.0187V26.17H33.0387V24.85H32.2887V26.17H31.4887V26.83H32.2887V29.99C32.2887 30.71 32.6487 31.12 33.3587 31.12ZM35.4481 25.36C35.7281 25.36 35.9581 25.13 35.9581 24.85C35.9581 24.57 35.7281 24.35 35.4481 24.35C35.1781 24.35 34.9481 24.57 34.9481 24.85C34.9481 25.13 35.1781 25.36 35.4481 25.36ZM35.0781 31H35.8281V26.17H35.0781V31ZM39.4342 31.12C40.9042 31.12 41.8242 29.98 41.8242 28.58C41.8242 27.18 40.9042 26.05 39.4342 26.05C37.9642 26.05 37.0442 27.18 37.0442 28.58C37.0442 29.98 37.9642 31.12 39.4342 31.12ZM39.4342 30.45C38.4042 30.45 37.8242 29.57 37.8242 28.58C37.8242 27.6 38.4042 26.72 39.4342 26.72C40.4642 26.72 41.0342 27.6 41.0342 28.58C41.0342 29.57 40.4642 30.45 39.4342 30.45ZM46.3069 31H47.0569V27.61C47.0569 26.56 46.5269 26.05 45.5169 26.05C44.7969 26.05 44.1369 26.47 43.7969 26.87V26.17H43.0469V31H43.7969V27.47C44.0769 27.08 44.6369 26.72 45.2269 26.72C45.8769 26.72 46.3069 26.99 46.3069 27.84V31ZM51.1628 31H54.2028C55.4228 31 56.1328 30.27 56.1328 29.2C56.1328 28.4 55.5428 27.67 54.8328 27.56C55.4428 27.43 56.0028 26.87 56.0028 26.03C56.0028 25.03 55.2928 24.33 54.1328 24.33H51.1628V31ZM51.9928 27.22V25.07H53.9928C54.7428 25.07 55.1428 25.55 55.1428 26.15C55.1428 26.76 54.7428 27.22 53.9928 27.22H51.9928ZM51.9928 30.26V27.96H54.0328C54.8528 27.96 55.2728 28.5 55.2728 29.11C55.2728 29.82 54.8128 30.26 54.0328 30.26H51.9928Z"
      fill={gray['gray-800']}
    />
  </svg>
);

export const rating = () => (
  <svg
    width="120"
    height="20"
    viewBox="0 0 120 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="19.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M10.0857 13H10.9157V6.33H10.1857L8.51566 8.05L9.01566 8.56L10.0857 7.43V13Z"
      fill={gray['gray-600']}
    />
    <rect
      x="25.25"
      y="0.25"
      width="19.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M32.6005 13H37.1805V12.26H33.9105C35.7705 10.79 37.1505 9.55 37.1505 8.19C37.1505 6.86 36.0205 6.23 34.9105 6.23C33.9705 6.23 33.1005 6.61 32.5905 7.28L33.1005 7.81C33.4905 7.31 34.1105 6.97 34.9105 6.97C35.6005 6.97 36.3005 7.34 36.3005 8.19C36.3005 9.34 35.0005 10.45 32.6005 12.34V13Z"
      fill={gray['gray-600']}
    />
    <rect
      x="50.25"
      y="0.25"
      width="19.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M57.5068 12.02C57.9168 12.62 58.7468 13.12 59.8768 13.12C61.3468 13.12 62.2368 12.31 62.2368 11.2C62.2368 10.13 61.3068 9.61 60.6968 9.56C61.3268 9.45 62.1368 8.97 62.1368 8.01C62.1368 6.88 61.1568 6.23 59.8768 6.23C58.8468 6.23 58.0768 6.68 57.5968 7.26L58.0568 7.78C58.5468 7.25 59.0868 6.97 59.8168 6.97C60.6268 6.97 61.3068 7.37 61.3068 8.11C61.3068 8.88 60.5968 9.21 59.7568 9.21C59.4868 9.21 59.1768 9.21 59.0668 9.2V9.96C59.1668 9.95 59.4768 9.95 59.7568 9.95C60.7368 9.95 61.4168 10.3 61.4168 11.13C61.4168 11.9 60.8268 12.38 59.8568 12.38C59.0668 12.38 58.3868 12.02 57.9968 11.5L57.5068 12.02Z"
      fill={gray['gray-600']}
    />
    <rect
      x="75.25"
      y="0.25"
      width="19.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M85.7019 13H86.5319V11.31H87.4719V10.58H86.5319V6.33H85.3919L82.5319 10.62V11.31H85.7019V13ZM85.7019 7.1V10.58H83.3619L85.7019 7.1Z"
      fill={gray['gray-600']}
    />
    <rect
      x="100.25"
      y="0.25"
      width="19.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M107.711 12.05C108.211 12.71 108.931 13.12 110.061 13.12C111.401 13.12 112.431 12.28 112.431 10.92C112.431 9.55 111.421 8.79 110.311 8.79C109.641 8.79 109.071 9.07 108.751 9.39V7.07H112.001V6.33H107.921V9.93L108.531 10.14C108.981 9.7 109.481 9.51 110.071 9.51C110.971 9.51 111.601 10.07 111.601 10.95C111.601 11.76 110.971 12.38 110.061 12.38C109.241 12.38 108.661 12.06 108.221 11.5L107.711 12.05Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const relationship = () => (
  <svg
    width="116"
    height="25"
    viewBox="0 0 116 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="3.25"
      width="39.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <rect
      x="76.25"
      y="3.25"
      width="39.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M67.4375 6.25C68.0556 6.25 68.6598 6.06672 69.1737 5.72334C69.6876 5.37996 70.0881 4.89191 70.3246 4.32089C70.5611 3.74987 70.623 3.12154 70.5025 2.51534C70.3819 1.90915 70.0842 1.35233 69.6472 0.915293C69.2102 0.478254 68.6533 0.180626 68.0472 0.0600474C67.441 -0.0605314 66.8126 0.001354 66.2416 0.237878C65.6706 0.474402 65.1825 0.874941 64.8392 1.38884C64.4958 1.90275 64.3125 2.50693 64.3125 3.125C64.3125 3.9538 64.6417 4.74866 65.2278 5.33471C65.8138 5.92076 66.6087 6.25 67.4375 6.25ZM67.4375 1.5625C67.7465 1.5625 68.0486 1.65414 68.3056 1.82583C68.5625 1.99752 68.7628 2.24155 68.8811 2.52706C68.9993 2.81257 69.0303 3.12673 68.97 3.42983C68.9097 3.73293 68.7609 4.01134 68.5424 4.22986C68.3238 4.44838 68.0454 4.59719 67.7423 4.65748C67.4392 4.71777 67.1251 4.68683 66.8396 4.56856C66.554 4.4503 66.31 4.25003 66.1383 3.99308C65.9666 3.73613 65.875 3.43403 65.875 3.125C65.875 2.7106 66.0396 2.31317 66.3326 2.02015C66.6257 1.72712 67.0231 1.5625 67.4375 1.5625ZM69 7.8125H65.875C65.4027 7.81246 64.9366 7.92025 64.5122 8.12765C64.0878 8.33505 63.7164 8.63658 63.4263 9.00928C64.0098 9.07019 64.5635 9.29747 65.0215 9.66406C65.2705 9.49609 65.5527 9.375 65.875 9.375H69C69.4144 9.375 69.8118 9.53962 70.1049 9.83265C70.3979 10.1257 70.5625 10.5231 70.5625 10.9375V17.1875H69V23.4375H65.875V19.2285L65.2891 19.8052C65.0072 20.0828 64.676 20.3053 64.3125 20.4614V23.4375C64.3125 23.8519 64.4771 24.2493 64.7701 24.5424C65.0632 24.8354 65.4606 25 65.875 25H69C69.4144 25 69.8118 24.8354 70.1049 24.5424C70.3979 24.2493 70.5625 23.8519 70.5625 23.4375V18.75C70.9769 18.75 71.3743 18.5854 71.6674 18.2924C71.9604 17.9993 72.125 17.6019 72.125 17.1875V10.9375C72.125 10.1087 71.7958 9.31384 71.2097 8.72779C70.6237 8.14174 69.8288 7.8125 69 7.8125ZM50.25 19.229V23.4375H47.125V17.1875H45.5625V10.9375C45.5625 10.5231 45.7271 10.1257 46.0201 9.83265C46.3132 9.53962 46.7106 9.375 47.125 9.375H50.25C50.5723 9.375 50.855 9.49658 51.104 9.66406C51.5628 9.29811 52.1173 9.07199 52.7012 9.0127C52.4111 8.6391 52.0394 8.33675 51.6146 8.12875C51.1898 7.92074 50.723 7.81257 50.25 7.8125H47.125C46.2962 7.8125 45.5013 8.14174 44.9153 8.72779C44.3292 9.31384 44 10.1087 44 10.9375V17.1875C44 17.6019 44.1646 17.9993 44.4576 18.2924C44.7507 18.5854 45.1481 18.75 45.5625 18.75V23.4375C45.5625 23.8519 45.7271 24.2493 46.0201 24.5424C46.3132 24.8354 46.7106 25 47.125 25H50.25C50.6644 25 51.0618 24.8354 51.3549 24.5424C51.6479 24.2493 51.8125 23.8519 51.8125 23.4375V20.4624C51.4491 20.3057 51.1179 20.0829 50.8359 19.8052L50.25 19.229ZM48.6875 6.25C49.3056 6.25 49.9098 6.06672 50.4237 5.72334C50.9376 5.37996 51.3381 4.89191 51.5746 4.32089C51.8111 3.74987 51.873 3.12154 51.7525 2.51534C51.6319 1.90915 51.3342 1.35233 50.8972 0.915293C50.4602 0.478254 49.9033 0.180626 49.2972 0.0600474C48.691 -0.0605314 48.0626 0.001354 47.4916 0.237878C46.9206 0.474402 46.4325 0.874941 46.0892 1.38884C45.7458 1.90275 45.5625 2.50693 45.5625 3.125C45.5625 3.9538 45.8917 4.74866 46.4778 5.33471C47.0638 5.92076 47.8587 6.25 48.6875 6.25ZM48.6875 1.5625C48.9965 1.5625 49.2986 1.65414 49.5556 1.82583C49.8125 1.99752 50.0128 2.24155 50.1311 2.52706C50.2493 2.81257 50.2803 3.12673 50.22 3.42983C50.1597 3.73293 50.0109 4.01134 49.7924 4.22986C49.5738 4.44838 49.2954 4.59719 48.9923 4.65748C48.6892 4.71777 48.3751 4.68683 48.0896 4.56856C47.804 4.4503 47.56 4.25003 47.3883 3.99308C47.2166 3.73613 47.125 3.43403 47.125 3.125C47.125 2.7106 47.2896 2.31317 47.5826 2.02015C47.8757 1.72712 48.2731 1.5625 48.6875 1.5625ZM67.0903 14.8438C67.0903 14.6365 67.0491 14.4314 66.969 14.2403C66.889 14.0491 66.7717 13.8758 66.624 13.7305L63.8462 10.9961C62.8301 9.99561 61.1875 10.7676 61.1875 12.1094V14.0625H54.9375V12.1094C54.9375 10.771 53.2861 10.0044 52.2788 10.9961L49.501 13.7305C49.3533 13.8759 49.2361 14.0492 49.1561 14.2403C49.0761 14.4314 49.0348 14.6365 49.0348 14.8438C49.0348 15.051 49.0761 15.2561 49.1561 15.4472C49.2361 15.6383 49.3533 15.8116 49.501 15.957L52.2788 18.6914C53.3188 19.7168 54.9375 18.8867 54.9375 17.5781V15.625H61.1875V17.5781C61.1875 18.8965 62.8164 19.7056 63.8462 18.6914L66.624 15.957C66.7717 15.8117 66.889 15.6384 66.969 15.4472C67.0491 15.2561 67.0903 15.051 67.0903 14.8438ZM53.375 17.5781L50.5972 14.8438L53.375 12.1094V17.5781ZM62.75 17.5781V12.1094L65.5278 14.8438L62.75 17.5781Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const status = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M87.7875 12.6774L84.0881 9.00797C83.9706 8.89049 83.9706 8.70052 84.0881 8.58303L84.583 8.08811C84.7005 7.97063 84.8905 7.97063 85.008 8.08811L88 11.0501L90.992 8.08811C91.1095 7.97063 91.2995 7.97063 91.417 8.08811L91.9119 8.58303C92.0294 8.70052 92.0294 8.89049 91.9119 9.00797L88.2125 12.6774C88.095 12.7949 87.905 12.7949 87.7875 12.6774Z"
      fill={gray['gray-600']}
    />
    <path
      d="M15.38 12.06C15.93 12.68 16.78 13.12 17.94 13.12C19.74 13.12 20.4 12.13 20.4 11.16C20.4 9.76 19.16 9.42 18.07 9.13C17.22 8.9 16.45 8.7 16.45 8.03C16.45 7.4 17.02 6.97 17.82 6.97C18.55 6.97 19.25 7.22 19.75 7.77L20.25 7.16C19.69 6.57 18.9 6.23 17.88 6.23C16.57 6.23 15.59 6.98 15.59 8.08C15.59 9.39 16.78 9.69 17.85 9.97C18.73 10.21 19.54 10.43 19.54 11.23C19.54 11.74 19.16 12.38 17.97 12.38C17.03 12.38 16.31 11.92 15.87 11.43L15.38 12.06ZM24.8694 13H25.6194V8.17H24.8694V11.72C24.5894 12.11 24.0294 12.45 23.4394 12.45C22.7894 12.45 22.3594 12.2 22.3594 11.35V8.17H21.6094V11.58C21.6094 12.63 22.1394 13.12 23.1494 13.12C23.8694 13.12 24.4994 12.74 24.8694 12.32V13ZM26.8372 10.58C26.8372 12.02 27.8072 13.12 29.2472 13.12C30.1272 13.12 30.6472 12.76 31.0172 12.28L30.5172 11.82C30.1972 12.25 29.7872 12.45 29.2872 12.45C28.2572 12.45 27.6172 11.65 27.6172 10.58C27.6172 9.51 28.2572 8.72 29.2872 8.72C29.7872 8.72 30.1972 8.91 30.5172 9.35L31.0172 8.89C30.6472 8.41 30.1272 8.05 29.2472 8.05C27.8072 8.05 26.8372 9.15 26.8372 10.58ZM31.7884 10.58C31.7884 12.02 32.7584 13.12 34.1984 13.12C35.0784 13.12 35.5984 12.76 35.9684 12.28L35.4684 11.82C35.1484 12.25 34.7384 12.45 34.2384 12.45C33.2084 12.45 32.5684 11.65 32.5684 10.58C32.5684 9.51 33.2084 8.72 34.2384 8.72C34.7384 8.72 35.1484 8.91 35.4684 9.35L35.9684 8.89C35.5984 8.41 35.0784 8.05 34.1984 8.05C32.7584 8.05 31.7884 9.15 31.7884 10.58ZM36.7395 10.58C36.7395 12.09 37.7695 13.12 39.1995 13.12C39.9895 13.12 40.6395 12.86 41.1195 12.38L40.7595 11.89C40.3795 12.28 39.8195 12.5 39.2695 12.5C38.2295 12.5 37.5895 11.74 37.5295 10.83H41.4395V10.64C41.4395 9.19 40.5795 8.05 39.1195 8.05C37.7395 8.05 36.7395 9.18 36.7395 10.58ZM39.1095 8.67C40.2095 8.67 40.6895 9.56 40.6995 10.28H37.5295C37.5695 9.54 38.0795 8.67 39.1095 8.67ZM42.2343 12.36C42.7243 12.88 43.3943 13.12 44.1843 13.12C45.4343 13.12 46.0843 12.47 46.0843 11.66C46.0843 10.59 45.1143 10.35 44.2743 10.16C43.6443 10.01 43.0943 9.86 43.0943 9.39C43.0943 8.96 43.5043 8.66 44.1643 8.66C44.7843 8.66 45.3143 8.92 45.6043 9.27L45.9543 8.75C45.5643 8.36 44.9843 8.05 44.1643 8.05C43.0143 8.05 42.3643 8.69 42.3643 9.44C42.3643 10.44 43.2943 10.66 44.1143 10.85C44.7643 11.01 45.3543 11.18 45.3543 11.71C45.3543 12.18 44.9543 12.51 44.2143 12.51C43.5543 12.51 42.9443 12.19 42.6243 11.82L42.2343 12.36ZM46.8827 12.36C47.3727 12.88 48.0427 13.12 48.8327 13.12C50.0827 13.12 50.7327 12.47 50.7327 11.66C50.7327 10.59 49.7627 10.35 48.9227 10.16C48.2927 10.01 47.7427 9.86 47.7427 9.39C47.7427 8.96 48.1527 8.66 48.8127 8.66C49.4327 8.66 49.9627 8.92 50.2527 9.27L50.6027 8.75C50.2127 8.36 49.6327 8.05 48.8127 8.05C47.6627 8.05 47.0127 8.69 47.0127 9.44C47.0127 10.44 47.9427 10.66 48.7627 10.85C49.4127 11.01 50.0027 11.18 50.0027 11.71C50.0027 12.18 49.6027 12.51 48.8627 12.51C48.2027 12.51 47.5927 12.19 47.2727 11.82L46.8827 12.36Z"
      fill={gray['gray-800']}
    />
    <rect x="6" y="7" width="5" height="5" rx="2.5" fill={green['green-700']} />
  </svg>
);

export const teamSelector = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M8.91 13.12C10.12 13.12 10.92 12.56 11.48 11.8L10.77 11.41C10.39 11.98 9.7 12.38 8.91 12.38C7.48 12.38 6.37 11.25 6.37 9.67C6.37 8.08 7.48 6.96 8.91 6.96C9.7 6.96 10.39 7.37 10.77 7.93L11.47 7.54C10.94 6.79 10.12 6.22 8.91 6.22C7.02 6.22 5.51 7.62 5.51 9.67C5.51 11.72 7.02 13.12 8.91 13.12ZM15.7778 13H16.5278V9.59C16.5278 8.54 15.9978 8.05 14.9878 8.05C14.2578 8.05 13.5978 8.47 13.2578 8.87V6.33H12.5078V13H13.2578V9.47C13.5478 9.08 14.1078 8.72 14.6878 8.72C15.3378 8.72 15.7778 8.97 15.7778 9.82V13ZM20.1354 13.12C21.6054 13.12 22.5254 11.98 22.5254 10.58C22.5254 9.18 21.6054 8.05 20.1354 8.05C18.6654 8.05 17.7454 9.18 17.7454 10.58C17.7454 11.98 18.6654 13.12 20.1354 13.12ZM20.1354 12.45C19.1054 12.45 18.5254 11.57 18.5254 10.58C18.5254 9.6 19.1054 8.72 20.1354 8.72C21.1654 8.72 21.7354 9.6 21.7354 10.58C21.7354 11.57 21.1654 12.45 20.1354 12.45ZM25.858 13.12C27.328 13.12 28.248 11.98 28.248 10.58C28.248 9.18 27.328 8.05 25.858 8.05C24.388 8.05 23.468 9.18 23.468 10.58C23.468 11.98 24.388 13.12 25.858 13.12ZM25.858 12.45C24.828 12.45 24.248 11.57 24.248 10.58C24.248 9.6 24.828 8.72 25.858 8.72C26.888 8.72 27.458 9.6 27.458 10.58C27.458 11.57 26.888 12.45 25.858 12.45ZM29.0507 12.36C29.5407 12.88 30.2107 13.12 31.0007 13.12C32.2507 13.12 32.9007 12.47 32.9007 11.66C32.9007 10.59 31.9307 10.35 31.0907 10.16C30.4607 10.01 29.9107 9.86 29.9107 9.39C29.9107 8.96 30.3207 8.66 30.9807 8.66C31.6007 8.66 32.1307 8.92 32.4207 9.27L32.7707 8.75C32.3807 8.36 31.8007 8.05 30.9807 8.05C29.8307 8.05 29.1807 8.69 29.1807 9.44C29.1807 10.44 30.1107 10.66 30.9307 10.85C31.5807 11.01 32.1707 11.18 32.1707 11.71C32.1707 12.18 31.7707 12.51 31.0307 12.51C30.3707 12.51 29.7607 12.19 29.4407 11.82L29.0507 12.36ZM33.8391 10.58C33.8391 12.09 34.8691 13.12 36.2991 13.12C37.0891 13.12 37.7391 12.86 38.2191 12.38L37.8591 11.89C37.4791 12.28 36.9191 12.5 36.3691 12.5C35.3291 12.5 34.6891 11.74 34.6291 10.83H38.5391V10.64C38.5391 9.19 37.6791 8.05 36.2191 8.05C34.8391 8.05 33.8391 9.18 33.8391 10.58ZM36.2091 8.67C37.3091 8.67 37.7891 9.56 37.7991 10.28H34.6291C34.6691 9.54 35.1791 8.67 36.2091 8.67ZM44.012 13H44.842V7.07H46.962V6.33H41.902V7.07H44.012V13ZM46.6028 10.58C46.6028 12.09 47.6328 13.12 49.0628 13.12C49.8528 13.12 50.5028 12.86 50.9828 12.38L50.6228 11.89C50.2428 12.28 49.6828 12.5 49.1328 12.5C48.0928 12.5 47.4528 11.74 47.3928 10.83H51.3028V10.64C51.3028 9.19 50.4428 8.05 48.9828 8.05C47.6028 8.05 46.6028 9.18 46.6028 10.58ZM48.9728 8.67C50.0728 8.67 50.5528 9.56 50.5628 10.28H47.3928C47.4328 9.54 47.9428 8.67 48.9728 8.67ZM55.5376 13H56.2876V9.68C56.2876 8.51 55.4376 8.05 54.4176 8.05C53.6276 8.05 53.0076 8.31 52.4876 8.85L52.8376 9.37C53.2676 8.91 53.7376 8.7 54.3176 8.7C55.0176 8.7 55.5376 9.07 55.5376 9.72V10.59C55.1476 10.14 54.5976 9.93 53.9376 9.93C53.1176 9.93 52.2476 10.44 52.2476 11.52C52.2476 12.57 53.1176 13.12 53.9376 13.12C54.5876 13.12 55.1376 12.89 55.5376 12.45V13ZM55.5376 11.98C55.2476 12.38 54.7376 12.58 54.2076 12.58C53.5076 12.58 53.0176 12.14 53.0176 11.53C53.0176 10.91 53.5076 10.47 54.2076 10.47C54.7376 10.47 55.2476 10.67 55.5376 11.07V11.98ZM63.621 13H64.371V9.51C64.371 8.54 63.901 8.05 63.021 8.05C62.321 8.05 61.671 8.51 61.401 8.95C61.261 8.45 60.841 8.05 60.101 8.05C59.391 8.05 58.741 8.56 58.541 8.87V8.17H57.791V13H58.541V9.47C58.801 9.08 59.321 8.72 59.811 8.72C60.441 8.72 60.701 9.11 60.701 9.72V13H61.451V9.46C61.701 9.08 62.231 8.72 62.731 8.72C63.351 8.72 63.621 9.11 63.621 9.72V13Z"
      fill={gray['gray-600']}
    />
    <path
      d="M89.5714 10C90.5179 10 91.2857 9.23214 91.2857 8.28571C91.2857 7.33929 90.5179 6.57143 89.5714 6.57143C88.625 6.57143 87.8571 7.33929 87.8571 8.28571C87.8571 9.23214 88.625 10 89.5714 10ZM89.5714 7.14286C90.2018 7.14286 90.7143 7.65536 90.7143 8.28571C90.7143 8.91607 90.2018 9.42857 89.5714 9.42857C88.9411 9.42857 88.4286 8.91607 88.4286 8.28571C88.4286 7.65536 88.9411 7.14286 89.5714 7.14286ZM84.4286 10C85.5339 10 86.4286 9.10536 86.4286 8C86.4286 6.89464 85.5339 6 84.4286 6C83.3232 6 82.4286 6.89464 82.4286 8C82.4286 9.10536 83.3232 10 84.4286 10ZM84.4286 6.57143C85.2161 6.57143 85.8571 7.2125 85.8571 8C85.8571 8.7875 85.2161 9.42857 84.4286 9.42857C83.6411 9.42857 83 8.7875 83 8C83 7.2125 83.6411 6.57143 84.4286 6.57143ZM85.8589 10.3571C85.2625 10.3571 85.1143 10.5714 84.4286 10.5714C83.7429 10.5714 83.5946 10.3571 82.9982 10.3571C82.35 10.3571 81.7196 10.6464 81.35 11.1946C81.1286 11.5232 81 11.9179 81 12.3429V13.1429C81 13.6161 81.3839 14 81.8571 14H87C87.4732 14 87.8571 13.6161 87.8571 13.1429V12.3429C87.8571 11.9179 87.7286 11.5232 87.5071 11.1946C87.1375 10.6464 86.5071 10.3571 85.8589 10.3571ZM87.2857 13.1429C87.2857 13.3 87.1571 13.4286 87 13.4286H81.8571C81.7 13.4286 81.5714 13.3 81.5714 13.1429V12.3429C81.5714 12.0464 81.6589 11.7589 81.8232 11.5143C82.0696 11.1482 82.5089 10.9286 82.9964 10.9286C83.4857 10.9286 83.6607 11.1429 84.4286 11.1429C85.1964 11.1429 85.3714 10.9286 85.8589 10.9286C86.3464 10.9286 86.7857 11.1482 87.0321 11.5143C87.1964 11.7589 87.2839 12.0464 87.2839 12.3429V13.1429H87.2857ZM92.1375 11.0911C91.8286 10.6339 91.3036 10.3929 90.7643 10.3929C90.2679 10.3929 90.1429 10.5714 89.5714 10.5714C89 10.5714 88.875 10.3929 88.3786 10.3929C88.1429 10.3929 87.9125 10.4464 87.6982 10.5375C87.9696 10.8125 88.0286 10.9589 88.0589 11.0125C88.1607 10.9839 88.2661 10.9661 88.3786 10.9661C88.7679 10.9661 88.9143 11.1446 89.5714 11.1446C90.2286 11.1446 90.375 10.9661 90.7643 10.9661C91.1393 10.9661 91.475 11.1321 91.6643 11.4125C91.7911 11.6 91.8589 11.8214 91.8589 12.05V12.7143C91.8589 12.7929 91.7946 12.8571 91.7161 12.8571H88.4286C88.4286 13.1732 88.4339 13.2589 88.4 13.4286H91.7143C92.1089 13.4286 92.4286 13.1089 92.4286 12.7143V12.0482C92.4286 11.6929 92.3214 11.3643 92.1375 11.0911Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const text = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="97.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
  </svg>
);

export const yesNoQuestion = () => (
  <svg
    width="85"
    height="20"
    viewBox="0 0 85 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="39.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M15.0833 13H15.9133V10.18L18.5333 6.33H17.5633L15.4933 9.43L13.4233 6.33H12.4533L15.0833 10.18V13ZM17.8235 10.58C17.8235 12.09 18.8535 13.12 20.2835 13.12C21.0735 13.12 21.7235 12.86 22.2035 12.38L21.8435 11.89C21.4635 12.28 20.9035 12.5 20.3535 12.5C19.3135 12.5 18.6735 11.74 18.6135 10.83H22.5235V10.64C22.5235 9.19 21.6635 8.05 20.2035 8.05C18.8235 8.05 17.8235 9.18 17.8235 10.58ZM20.1935 8.67C21.2935 8.67 21.7735 9.56 21.7835 10.28H18.6135C18.6535 9.54 19.1635 8.67 20.1935 8.67ZM23.3183 12.36C23.8083 12.88 24.4783 13.12 25.2683 13.12C26.5183 13.12 27.1683 12.47 27.1683 11.66C27.1683 10.59 26.1983 10.35 25.3583 10.16C24.7283 10.01 24.1783 9.86 24.1783 9.39C24.1783 8.96 24.5883 8.66 25.2483 8.66C25.8683 8.66 26.3983 8.92 26.6883 9.27L27.0383 8.75C26.6483 8.36 26.0683 8.05 25.2483 8.05C24.0983 8.05 23.4483 8.69 23.4483 9.44C23.4483 10.44 24.3783 10.66 25.1983 10.85C25.8483 11.01 26.4383 11.18 26.4383 11.71C26.4383 12.18 26.0383 12.51 25.2983 12.51C24.6383 12.51 24.0283 12.19 23.7083 11.82L23.3183 12.36Z"
      fill={gray['gray-600']}
    />
    <rect
      x="45.25"
      y="0.25"
      width="39.5"
      height="19.5"
      rx="1.75"
      fill="white"
      stroke={gray['gray-600']}
      strokeWidth="0.5"
    />
    <path
      d="M64.0986 13H64.8986V6.33H64.0686V11.6L60.2286 6.33H59.3786V13H60.2086V7.62L64.0986 13ZM68.5387 13.12C70.0087 13.12 70.9287 11.98 70.9287 10.58C70.9287 9.18 70.0087 8.05 68.5387 8.05C67.0687 8.05 66.1487 9.18 66.1487 10.58C66.1487 11.98 67.0687 13.12 68.5387 13.12ZM68.5387 12.45C67.5087 12.45 66.9287 11.57 66.9287 10.58C66.9287 9.6 67.5087 8.72 68.5387 8.72C69.5687 8.72 70.1387 9.6 70.1387 10.58C70.1387 11.57 69.5687 12.45 68.5387 12.45Z"
      fill={gray['gray-600']}
    />
  </svg>
);

export const STAGE_STATUSES = {
  open: 'open',
  won: 'won',
  lost: 'lost',
  disqualified: 'disqualified',
};

export const FIELD_TYPES = {
  ActivityCustomField: {
    label: 'Activity Custom Field',
    type: 'activity_custom_field',
  },
  Checkbox: {
    label: 'Checkbox',
    type: 'checkbox',
    icon: checkbox,
    placeholder: 'Choose Option',
    localizedPlaceholder: (t: TFn) => t('Choose Option'),
  },
  Checkboxes: {
    label: 'Checkboxes',
    type: 'checkboxes',
    icon: checkboxes,
    localizedPlaceholder: (t: TFn) => t('Find Options'),
  },
  Choices: {
    label: 'Choices',
    type: 'choices',
  },
  Date: {
    label: 'Date',
    type: 'date',
    icon: date,
    placeholder: 'MM/DD/YYYY',
  },
  DateTime: {
    label: 'DateTime',
    type: 'datetime',
    icon: date,
  },
  DealStageSelector: {
    label: 'Deal Stage Selector',
    type: 'deal_stage_selector',
  },
  Dropdown: {
    label: 'Dropdown',
    type: 'dropdown',
    icon: dropdown,
    placeholder: 'Choose Option',
    localizedPlaceholder: (t: TFn) => t('Choose Option'),
  },
  DynamicTags: {
    label: 'Dynamic Tags',
    type: 'dynamictags',
    icon: dynamicTags,
    placeholder: 'Choose Tag',
  },
  Email: {
    label: 'Email Address',
    type: 'email',
    icon: emailAddress,
  },
  Files: {
    label: 'Files',
    type: 'files',
    icon: files,
  },
  FileUploader: {
    label: 'File Uploader',
    type: 'file_uploader',
  },
  LongText: {
    label: 'Long Text',
    type: 'longtext',
    icon: longText,
    localizedPlaceholder: (t: TFn) => t('Enter Text'),
  },
  Decimal: {
    label: 'Number (Decimal)',
    type: 'decimal',
    icon: numberDecimal,
    placeholder: '0.00',
  },
  Integer: {
    label: 'Number (Whole)',
    type: 'integer',
    icon: numberWhole,
    placeholder: '0',
  },
  Number: {
    label: 'Number',
    type: 'number',
  },
  PhoneNumber: {
    label: 'Phone Number',
    type: 'phonenumber',
    icon: phoneNumber,
  },
  Money: {
    label: 'Price',
    type: 'money',
    icon: price,
    placeholder: '0.00',
  },
  Phone: {
    label: 'Phone',
    type: 'phone',
  },
  Price: {
    label: 'Price',
    type: 'price',
  },
  Radio: {
    label: 'Radio Buttons',
    type: 'radio',
    icon: radioButtons,
    placeholder: 'Choose Option',
    localizedPlaceholder: (t: TFn) => t('Choose Option'),
  },
  Rating: {
    label: 'Rating',
    type: 'rating',
    icon: rating,
    placeholder: 'Choose Value',
    localizedPlaceholder: (t: TFn) => t('Choose Rating'),
  },
  Relationship: {
    label: 'Relationship',
    type: 'relationship',
    icon: relationship,
  },
  Status: {
    label: 'Status',
    type: 'status',
    icon: status,
    placeholder: 'Choose Status',
    localizedPlaceholder: (t: TFn) => t('Choose Status'),
  },
  Selector: {
    label: 'Team Selector',
    type: 'selector',
    icon: teamSelector,
    placeholder: 'Find Team Member',
  },
  SurveyCheckbox: {
    label: 'Survey Checkbox',
  },
  SurveyDropdown: {
    label: 'Survey Dropdown',
    type: 'survey_dropdown',
  },
  SurveyNumber: {
    label: 'Survey Number',
    type: 'survey_number',
  },
  SurveyRating: {
    label: 'Survey Rating',
    type: 'survey_rating',
  },
  SurveyTextArea: {
    label: 'Survey Textarea',
    type: 'survey_textarea',
  },
  SurveyTextBox: {
    label: 'Survey Text Box',
    type: 'survey_textbox',
  },
  SurveyYesNo: {
    label: 'Survey Yes No',
    type: 'survey_yes_no',
  },
  TextArea: {
    label: 'Textarea',
    type: 'textarea',
  },
  Text: {
    label: 'Text',
    type: 'text',
    icon: text,
    getPlaceholder: (item: string) => `Enter ${item}`,
    localizedPlaceholder: (t: TFn) => t('Enter Text'),
  },
  TextBox: {
    label: 'Text Box',
    type: 'textbox',
  },
  YesNo: {
    label: 'Yes No',
    type: 'yes_no',
  },
  YesNoMaybe: {
    label: 'Yes/No Question',
    type: 'yesnomaybe',
    icon: yesNoQuestion,
    placeholder: 'Choose Option',
    localizedPlaceholder: (t: TFn) => t('Choose Option'),
  },
  TeamSelector: {
    label: 'Team Selector',
    type: 'team_selector',
    localizedPlaceholder: (t: TFn) => t('Find Team Member'),
  },
  Timezone: {
    label: 'Timezone',
    type: 'timezone',
    placeholder: 'Choose Option',
    localizedPlaceholder: (t: TFn, config?: { [key: string]: any }) =>
      t('Choose Option'),
  },
};

export const builderFieldWithMutablePlaceholderTypes = [
  FIELD_TYPES.Text.type,
  FIELD_TYPES.LongText.type,
  FIELD_TYPES.TextArea.type,
  FIELD_TYPES.TextBox.type,
  FIELD_TYPES.SurveyTextBox.type,
  FIELD_TYPES.SurveyTextArea.type,
  FIELD_TYPES.Decimal.type,
  FIELD_TYPES.Integer.type,
  FIELD_TYPES.Number.type,
  FIELD_TYPES.Price.type,
  FIELD_TYPES.Money.type,
];

export const DROPDOWN_SHOULD_LOAD = Symbol('dropdown_should_load');
